export default "__VITE_PUBLIC_ASSET__d2864e84__"